<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7">
          <money-box-edit-form v-if="moneybox" :moneybox="moneybox" @codeChange="codeChange">
          </money-box-edit-form>
        </div>
        <div class="col-md-4">
          <card style="width: max-content;" v-if="moneybox">
            <span style="margin-bottom: 10px;display: inline-block;">QR Kod Alanı</span>
            <qrcode-vue v-if="moneybox.code.length" :value="'mbapp01-'+moneybox.code" :size="150" level="H" />
            <qrcode-vue v-if="moneybox.code.length" ref="qrDownload" :value="'mbapp01-'+moneybox.code" :size="1000" level="H" style="display: none;" />
            <div v-if="moneybox.code.length" style="margin-top: 10px;">
              <a-button size="small" @click="downloadQr">QR Kodu İndir</a-button>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import QrcodeVue from 'qrcode.vue'
  import MoneyBoxEditForm from './MoneyBox/MoneyBoxEditForm.vue'

  export default {
    mounted() {
      const self = this
       self.$store.dispatch("Moneybox/requestMoneyboxShow", self.$route.params.id).then((moneybox)=> {
        self.moneybox = moneybox
       })
    },
    components: {
      MoneyBoxEditForm,
      QrcodeVue
    },
    data(){
      return {
        code: '',
        moneybox: null,
      }
    },
    methods:{
      codeChange(code){
        const self = this;
        self.code = 'mbapp01-'+code
      },
      downloadQr(){
        const canvas = this.$refs.qrDownload.$el.querySelector('canvas')
        if (!canvas) return
        const link = document.createElement('a')
        link.download = 'kumbara-' + this.moneybox.code + '-qr.png'
        link.href = canvas.toDataURL('image/png')
        link.click()
      }
    }
  }

</script>
<style>

</style>
